import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
//import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './material.module';

import {
	TranslatePipe,
	ObjTranslatePipe,
	SafeHTMLPipe,
	SafeStylePipe,
	SafeURLPipe,
	DefaultCurrencyPipe,
	DefaultAmountPipe,
	FilterPipe,
	VisualNumberPipe,
	PhonePipe,
	PaymentExpiration,
	WeightPipe,
	PmImagePipe,
	CardPipe,
	LocalDatePipe
} from './pipes/pipes';
import { ScrollSpyDirective, BgImageDirective, ImageSrcDirective } from './directives/directives';
import { NonemptyValidator, CreditCardValidator, CreditCardExpirationValidator, IdCardValidator, NameFieldValidator, ZipCodeValidator, CellFieldValidator } from './validators/validators';



@NgModule({ declarations: [
	TranslatePipe, ObjTranslatePipe, SafeHTMLPipe, SafeStylePipe, SafeURLPipe, DefaultCurrencyPipe, LocalDatePipe, DefaultAmountPipe, FilterPipe, VisualNumberPipe, PhonePipe, PaymentExpiration, WeightPipe, PmImagePipe, CardPipe,
	ScrollSpyDirective, BgImageDirective, ImageSrcDirective,
        NonemptyValidator, CreditCardValidator, CreditCardExpirationValidator, IdCardValidator, NameFieldValidator, ZipCodeValidator, CellFieldValidator,
    ],
    exports: [
        //BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
		TranslatePipe, ObjTranslatePipe, SafeHTMLPipe, SafeStylePipe, SafeURLPipe, DefaultCurrencyPipe, LocalDatePipe, DefaultAmountPipe, FilterPipe, VisualNumberPipe, PhonePipe, PaymentExpiration, WeightPipe, PmImagePipe, CardPipe,
		ScrollSpyDirective, BgImageDirective, ImageSrcDirective,
        NonemptyValidator, CreditCardValidator, CreditCardExpirationValidator, IdCardValidator, NameFieldValidator, ZipCodeValidator, CellFieldValidator,
    ], imports: [CommonModule,
        //BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
	], providers: [
        DefaultCurrencyPipe,
		LocalDatePipe,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class CoreModule { }
